import { BookOpen, Gauge } from 'lucide-react';
import type { PanelId } from '@trajectory/ui';
import { PANEL_GUIDES } from '@/lib/education';
import { useSettingsStore } from '@/stores/settingsStore';
import { useUiStore } from '@/stores/uiStore';

/** Compact context for panels that otherwise begin with dense engineering UI. */
export function PanelLearningBanner({ panelId }: { panelId: PanelId }) {
  const experienceLevel = useSettingsStore((state) => state.experienceLevel);
  const openEducationCenter = useUiStore((state) => state.openEducationCenter);
  const guide = PANEL_GUIDES[panelId];

  if (experienceLevel !== 'guided') return null;

  return (
    <div className="flex items-start gap-2 rounded-panel border border-info/25 bg-info/5 px-3 py-2 text-xs">
      <BookOpen className="mt-0.5 h-3.5 w-3.5 shrink-0 text-info" aria-hidden />
      <div className="min-w-0 flex-1">
        <p className="leading-relaxed text-muted">{guide.summary}</p>
        <p className="mt-1 leading-relaxed text-faint">
          <span className="font-medium text-text">Start:</span> {guide.firstAction}
        </p>
      </div>
      <button
        type="button"
        onClick={() => openEducationCenter()}
        title="Open learning centre for definitions, workflows, and model guidance"
        className="flex shrink-0 items-center gap-1 rounded-control px-1.5 py-1 text-info hover:bg-info/10"
      >
        <Gauge className="h-3 w-3" />
        Guide
      </button>
    </div>
  );
}
